SWRNEU.PJAX = function ($) {
  if ($.support.pjax) {

    // Set defauls
    $.pjax.defaults.scrollTo = 0;
    $.pjax.defaults.timeout = 2e4; // 2e4 => 20000
    $.pjax.defaults.container = '#content';
    $.pjax.defaults.fragment = '#content';
    $.pjax.defaults.maxCacheLength = 0;

    var $html = $('html');
    var $document = $(document);
    var oldSecondaryNavi = '';

    // Eventlisteners
    /**
     *
     */
    $document.on('click', '[data-pjax-reload]', function (event) {
      var options = {
        scrollTo: 0
      };

      var target;
      var targetSelector = $(this).data('target');

      if (targetSelector) {
        target = document.querySelector(targetSelector);
      }

      if (false !== ($(this).data('scrollto') || false) && target) {
        options.scrollTo = $(target).offset().top - (parseInt($html.css('--offset'), 10));
        console.debug('scrollTo', options.scrollTo);
      }

      $.pjax.reload($.pjax.defaults.container, options);
    });

    /**
     *
     */
    $document.on('click', '[data-spy=pjax]', function (event) {
      var $element = $(this);

      if (true === ($element.data('pjaxLoaded'))) {
        // Inhalt wurde bereits geladen
        return;
      }
      if (true === ($element.data('pjaxLoading'))) {
        // Es wird noch geladen
        return;
      }
      $element.data('pjaxLoading', true);

      var options = {
        push: $element.data('push') || false,
        url: $element.data('src'),
        scrollTo: false
      };

      if ('undefined' === typeof options.url) {
        $element.data('pjaxLoading', null);
        return;
      }

      if ('undefined' !== typeof $element.data('target')) {
        /*
         * Keine Unterstützung durch Sophora
         */
        //options.container = $element.data('target');
        //options.fragment = $element.data('target');
        if (false !== ($element.data('scrollto') || false)) {
          options.scrollTo = $($element.data('target')).offset().top - (parseInt($html.css('--offset'), 10));
          console.debug('scrollTo', options.scrollTo);
        }
      }

      if (false !== ($element.data('replace') || false)) {
        options.replace = true;
      }

      $element
        .on('pjax:complete', function () {
          $element.data('pjaxLoading', null);
        })
        .on('pjax:success', function () {
          if ('undefined' === typeof $element.attr('href')) {
            $element.data('pjaxLoaded', true);
          }
        });

      $.pjax(options);
    });

    /**
     *
     */
    $document.on('click', 'a', function (event) {
      var options = {};
      var $target = $(event.currentTarget);
      var href = $target.attr('href');

      if (!href || '#' === href.charAt(0) || !href.match('(/|\.html?)([?#]|$)') || href.indexOf('/-/') !== -1)
        return void (0);

      if ($target.attr('download') !== undefined)
        return void (0);

      if ($target.attr('target') && -1 !== $target.attr('target').indexOf('_blank'))
        return void (0);

      if ($target.attr('rel') && -1 !== $target.attr('rel').indexOf('external'))
        return void (0);

      if (0 !== $target.closest('li[data-external="true"]').length)
        return void (0);

      if ((new RegExp('~(rss|atom|podcast)')).test($target.attr('href')))
        return void (0);

      abortXhr(window.jQuery.pjax.xhr);

      var containerElement = $target.attr('data-pjax-container');
      if ('undefined' !== typeof containerElement) {
        var $element = 'undefined' !== typeof containerElement ? $(containerElement) : $(event.target);

        var top = $element.offset().top - ($(window).height() * .05);
        if ($element.closest('#inner-content-wrapper').length > 0) {
          options.scrollTo -= parseInt($('#inner-content-wrapper').css('padding-top'), 10);
          console.debug('scrollTo', options.scrollTo);
        }

        /*
         * Keine Unterstützung durch Sophora
         */
        //options.container = $target.attr('data-pjax-container');
        //options.fragment = $target.attr('data-pjax-container');
        options.push = false;
      }

      var targetElement = $target.data('target');
      if ('undefined' !== typeof targetElement && null !== document.querySelector(targetElement)) {
        /*
         * Keine Unterstützung durch Sophora
         */
        //options.container = $target.data('target');
        //options.fragment = $target.data('target');
        if (false !== ($target.data('scrollto') || false)) {
          var scrollTo = $(targetElement).offset().top - (parseInt($html.css('--offset'), 10));
          options.scrollTo = scrollTo;
          console.debug('scrollTo', scrollTo);
        }
      }

      if (false !== ($target.data('replace') || false)) {
        options.replace = true;
      }

      if (usePjax(options)) {
        $.pjax.click(event, options);
      }

      $document.one('pjax:end', function (_, __, ___) {
        document.body.focus();
      });
    });

    function usePjax (options) {
      if (options.container || '' !== '') {
        return true;
      }

      return !(document.location.host.match(/(www|standby)\.swrfernsehen\.de/)
        || document.location.host.match(/(www|standby)\.herzenssache\.de/)
        || (document.location.host.match(/.*(-vorschau\d).*/) && !document.location.pathname.match(/(\/cms\/)?\/dasding\/.*/)));
    }

    /**
     *
     */
    $document.on('submit', 'form[data-pjax]', function (event) {
      if (false === $(event.target).data('pjax')) {
        return;
      }

      $(event.target).find('[type=submit][data-disable-on-submit=true]').each(function (index, element) {
        if ($(event.target).attr('novalidate')) {
          //Ein UGC-Formular hat seine eigene "Button"-Disable-Funktion
          console.log('UGC-Formular');
          return;
        }
        if (this.hasAttribute('data-text-after-submit')) {
          if (this.tagName === 'BUTTON') {
            this.textContent = this.getAttribute('data-text-after-submit');
          } else {
            this.value = this.getAttribute('data-text-after-submit');
          }
        }
        this.disabled = true;
      });

      abortXhr(window.jQuery.pjax.xhr);

      var $btn = $(event.currentTarget).find('button[type=submit]');
      $btn.attr('autocomplete', 'off');
      $btn.prop('disabled', true);

      var element = $(event.currentTarget).attr('data-pjax-container');
      var $element = 'undefined' !== typeof element ? $(element) : $(event.target);

      var top = $element.offset().top - ($(window).height() * .05);
      if ($element.closest('#inner-content-wrapper').length > 0) {
        top -= parseInt($('#inner-content-wrapper').css('padding-top'), 10);
        console.debug('scrollTo', top);
      }
      top -= 136;

      if ('undefined' !== typeof element) {
        $.pjax.submit(event, $.pjax.defaults.container, {
          //fragment: element,
          scrollTo: top,
          push: false
        });
      } else {
        $.pjax.submit(event, $.pjax.defaults.container, {
          scrollTo: top
        });
      }

    });

    /**
     *
     */
    $document.on('pjax:beforeSend', function (event, jqXhr, options) {
      var $target = $(event.relatedTarget);
      var token = COMMON.Storage.local.getItem('userToken');

      if (options.url.indexOf('/mixtalk/') !== -1) {
        // Pjax-Request abbrechen und einen regulären Request auslösen
        window.location.href = options.url;
        return false;
      }

      if (token && $target.data('authorized')) {
        jqXhr.setRequestHeader('Authorization', 'Bearer ' + token);
      }
    });

    /**
     *
     */
    $document.on('pjax:send', function (event, xhr, options) {
      // noop
    });

    /**
     *
     */
    $document.on('pjax:beforeReplace', function (event, contents, options) {
      // class in <main> entfernen
      var $container = $(options.container);
      if ('main' === $container.prop('tagName').toLowerCase()) {
        $container.removeAttr('class');
      }
    });

    /**
     *
     */
    $document.on('pjax:beforeReplace', function (event, contents, options) {
      try {
        var $container = $($.pjax.defaults.container);
        $('button[type=submit][disabled]').each(function () {
          var $btn = $(this);
          if (0 === $container.has($btn).length) {
            $btn.prop('disabled', false);
          }
        });
      } catch (exception) {
      }
    });

    /**
     *
     */
    $document.on('pjax:success', function (event, data, status, xht, options) {
      //Damit der MutationObserver des ModuleLoader mitbekommt,
      //dass der Content via PJAX geladen wurde:
      window.contentChangeViaPjax = true;

      if(window.isFractal){
        $document.trigger('pjax:end');
        return;
      }

      var body = data.substring(data.indexOf('<body'), data.indexOf('</body>') + 7).replace(/[\n\r\t]/gm, '');
      var bodyAttributes = body.substring(6, body.indexOf('><'));
      var $shadowDom = $('<div></div>').append($.parseHTML(data, document));
      data = null;

      updateHead($shadowDom);
      updateBody(body, bodyAttributes);
      updateSecondLevelNavi($shadowDom);

      $shadowDom = null;
    });

    /**
     *
     */
    $document.on('pjax:timeout', function (event, xhr, options) {
      // Prevent default timeout redirection behavior
      event.preventDefault();
    });

    /**
     *
     */
    $document.on('pjax:error', function (event, xhr, textStatus, error, options) {
      options.success(xhr.responseText, textStatus, xhr);
      return !1;
    });

    /**
     *
     */
    $document.on('pjax:end', function (event, xhr, options) {
      var hash = window.location.hash.substring(1);
      if ('' === hash) {
        document.body.focus();
        return;
      }

      try {
        var target = document.querySelector('#' + hash + ',[name="' + hash + '"]');
      } catch (e) {
        document.body.focus();
        return;
      }
      if (target) {
        target.scrollIntoView({
          behavior: 'auto',
          block: 'start',
          inline: 'start'
        });

        // now account for fixed header
        var scrolledY = window.scrollY;
        if (scrolledY) {
          window.scroll(0, scrolledY - (120 + 16));
        }

        try {
          target.focus();
        } catch (e) {
        }
      }
    });

    /**
     *
     */
    $document.on('pjax:end', function (event, xhr, options) {
      try {
        var $element = $(options.container).find('[autofocus]');
        if (0 !== $element.length && 'function' === typeof $element[0].focus) {
          // Optimierung: Fokus im nächsten Frame setzen, um Reflow zu vermeiden.
          window.requestAnimationFrame(function () {
            $element[0].focus();
          });
        }
      } catch (exception) {
        console.error(exception.stack || exception);
      }
    });

    /**
     *
     */
    $document.on('pjax:start', function (event, xhr, options) {
      $document.trigger('loader.show');
    });

    $document.on('pjax:end', function (event, xhr, options) {
      $document.trigger('loader.hide');
    });

    $document.on('pjax:beforeReplace', function (event, xhr, options) {
      console.clear();
    });

    /**
     * SOS-25520
     * iOS nutzt für das Sharing offenbar bevorzugt OpenGraph-Elemente, daher müssen sie entfernt werden
     */
    $document.one('pjax:end', function () {
      $('meta[property^=og\\:]').remove();
      $('meta[name^=twitter\\:]').remove();
    });
  }

  function abortXhr (xhr) {
    if (xhr && xhr.readyState < 4) {
      xhr.onreadystatechange = $.noop;
      xhr.abort();
    }
  }

  function updateHead ($shadowDom) {
    //Elemente, die außerhalb des #content liegen und daher nicht automatisch ausgetauscht werden
    const items = [
      {
        //Canonical
        selector: 'link[rel="canonical"]',
        nodeType: 'link',
        type: 'rel',
        name: 'canonical',
        valueAttribute: 'href',
        parent: 'head'
      }, {
        selector: 'meta[name="swr:id"]',
        nodeType: 'meta',
        type: 'name',
        name: 'swr:id',
        valueAttribute: 'content',
        parent: 'head'
      }, {
        selector: 'meta[name="x-current-nav-item"]',
        nodeType: 'meta',
        type: 'http-equiv',
        name: 'x-current-nav-item',
        valueAttribute: 'content',
        parent: 'head'
      }, {
        //Favicon
        selector: 'link[rel="icon"]',
        nodeType: 'link',
        type: 'rel',
        name: 'icon',
        valueAttribute: 'href',
        parent: 'head'
      }, {
        //Manifest
        selector: 'link[rel="manifest"]',
        nodeType: 'link',
        type: 'rel',
        name: 'manifest',
        valueAttribute: 'href',
        parent: 'head'
      }
    ];

    items.forEach(function (item) {
      var $shadowElement = $shadowDom.find(item.selector);
      var $selectedElement = $(item.selector);

      //Das Element, das außerhalb des #content liegt,
      //existiert im HTML, das wir vom Server bekommen haben:
      if ($shadowElement.length > 0) {

        var value = $shadowElement.first().attr(item.valueAttribute);

        if ($selectedElement.length !== 0) {
          //Wenn es das Element bereits auf der Seite gibt, wird das
          //gewünschte Attribut mit dem neuen Wert gefüllt
          $selectedElement.attr(item.valueAttribute, value);
        } else {
          //Wenn es das Element NICHT auf der Seite gibt, wird das Element
          //erstellt und zur Seite hinzugefügt
          $selectedElement = $('<' + item.nodeType + ' />');
          $selectedElement.attr(item.type, item.name);
          $selectedElement.attr(item.valueAttribute, value);
          $selectedElement.appendTo(item.parent);
        }
      }

      //Das Element, das außerhalb des #content liegt,
      //existiert NICHT im HTML, das wir vom Server bekommen haben:
      if ($shadowElement.length === 0) {
        $selectedElement.remove();
      }
    });
  }

  function updateBody (body, bodyAttributes) {
//Elemente, die außerhalb des #content liegen und daher nicht automatisch ausgetauscht werden
    var items = [
      //Bodyklasse
      'class',
      //Body Station-ID
      'data-stationid'
    ];

    items.forEach(function (item) {
      var regEx = new RegExp(item + '="([^"]*)"');
      var attributeValue = bodyAttributes.match(regEx);

      $('body').attr(item, attributeValue[1]);
    });
  }

  function updateSecondLevelNavi ($shadowDom) {
    var $shadowElement = $shadowDom.find('#header-navi-second-level');

    if ($shadowElement.length > 0) {
      //Im PJAX-HTML vom Server existiert eine Second-Level-Navi.
      //Falls es bereits eine Second-Level-Navi gab, muss diese
      //ausgetauscht werden, andernfalls wird eine neue erzeugt.
      //In beiden Fällen wird das HTML, das in der PJAX-Antwort
      //steckt gespeichert, damit bei erneuter Navigation geschaut
      //werden kann, ob sich das HTML verändert hat. Denn nur dann
      //muss das HTML ausgetauscht und aktualisiert werden.

      var newSecondaryNaviHTML = $shadowElement.html();
      var $selectedElement = $('#header-navi-second-level');
      var change = false;

      if (oldSecondaryNavi !== '') {
        //Es gibt ein altes HTML der Second-Level-Navi
        if (oldSecondaryNavi !== newSecondaryNaviHTML) {
          //Das alte und das neue HTML unterscheiden sich
          oldSecondaryNavi = newSecondaryNaviHTML;
          change = true;
        }
      } else {
        //Es gibt kein altes HTML der Second-Level-Navi
        oldSecondaryNavi = newSecondaryNaviHTML;
        change = true;
      }

      if (change) {
        //Es ist die erste PJAX-Navigation innerhalb der Seite
        //oder bisher gab es keine Second-Level-Navi auf der Seite
        //und nun wurde zu einer Seite navigiert, die eine hat.

        if ($selectedElement.length !== 0) {
          //Wenn es bereits eine Second-Level-Navi gibt, wird sie ausgetauscht,
          //wenn sie sich geändert hat.
          console.log('Second-Level-Navi muss ausgetauscht werden.');

          $selectedElement.html($shadowElement.html());
        } else {
          //Wenn es noch keine Second-Level-Navi gibt, wird sie hinzugefügt
          console.log('Second-Level-Navi muss neu hinzugefügt werden.');

          $selectedElement = $('<div></div>');
          $selectedElement.addClass('container navbar-second-level');
          $selectedElement.attr('id', 'header-navi-second-level');
          $selectedElement.attr('data-nosnippet');
          $selectedElement.append($shadowElement.html());
          $('#header-navi').append($selectedElement);
        }

        //Da die Second-Level-Navi nur initialisiert werden soll,
        //wenn sich das HTML geändert hat und nicht bei jeder
        //PJAX-Navigation, wird aus dem PJAX-JS heraus dieses
        //Event getriggert.
        $document.on('pjax:end', function (){
          $document.trigger('swr:navigationswiper:init');
        });
      }
    }

    if ($shadowElement.length === 0) {
      //Im PJAX-HTML vom Server existiert keine Second-Level-Navi
      //und dementsprechend muss, falls es aktuell eine auf
      //der Seite gibt, diese entfernt werden.
      //Das existierende "alte" Second-Level-HTML, das für die
      //Ermittlung dient, ob die Second-Level-Navi ausgetauscht
      //werden soll, wird zurückgesetzt.

      oldSecondaryNavi = '';
      $selectedElement = $('#header-navi-second-level');

      if ('undefined' === typeof $selectedElement || $selectedElement.length !== 0) {
        //Wenn es auf der Seite eine Second-Level-Navi gibt, wird sie entfernt
        console.log('Second-Level-Navi muss entfernt werden.');

        $selectedElement.remove();
      }
    }
  }

  document.body.setAttribute('tabindex', '-1');

  /*
   * Public API
   */
  var PJAX = {};
  return PJAX;

}(window.jQuery);

